// Messages for operator/QuoteDetail (auto-merged into the i18n catalog by lib/i18n.ts).
export const en = {
  'operator.quote_detail.head': '{ref} — Quote',
  'operator.quote_detail.back': 'Back to quotes',
  'operator.quote_detail.change_status_aria': 'Change status',
  'operator.quote_detail.duplicate': 'Duplicate',
  'operator.quote_detail.edit': 'Edit quote',
  'operator.quote_detail.change_status': 'Change status',
  'operator.quote_detail.send': 'Send to customer',
  'operator.quote_detail.send.draft_hint': 'Sending will mark this draft as Sent.',
  'operator.quote_detail.details': 'Details',
  'operator.quote_detail.details.mode': 'Shipment type',
  'operator.quote_detail.details.load': 'Load type',
  'operator.quote_detail.details.incoterm': 'Incoterm',
  'operator.quote_detail.details.transit': 'Transit time',
  'operator.quote_detail.details.transit_days': '{days} days',
  'operator.quote_detail.details.loading_port': 'Loading port',
  'operator.quote_detail.details.origin_location': 'Origin location',
  'operator.quote_detail.details.discharge_port': 'Discharge port',
  'operator.quote_detail.details.final_destination': 'Final destination',
  'operator.quote_detail.details.cargo': 'Cargo details',
  'operator.quote_detail.details.remarks': 'Remarks',
  'operator.quote_detail.charges': 'Charges',
  'operator.quote_detail.charges.sub': 'Internal cost & margin — never sent to the customer portal',
  'operator.quote_detail.col.charge': 'Charge',
  'operator.quote_detail.col.cost': 'Cost',
  'operator.quote_detail.col.sell': 'Sell',
  'operator.quote_detail.col.margin': 'Margin',
  'operator.quote_detail.total': 'Total',
  'operator.quote_detail.save_as_template': 'Save as template',
  'operator.quote_detail.convert': 'Convert to shipment',
  'operator.quote_detail.duplicate_confirm.title': 'Duplicate this quote?',
  'operator.quote_detail.duplicate_confirm.body':
    'This creates a new draft quote copied from {ref}, including its line items. You can edit it afterwards.',
  'operator.quote_detail.convert_confirm.title': 'Convert to a shipment?',
  'operator.quote_detail.convert_confirm.body':
    'This books quote {ref} and creates a shipment from it, moving its messages and documents onto that shipment. This cannot be undone.',
  'operator.quote_detail.delete': 'Delete',
  'operator.quote_detail.delete_aria': 'Delete quote',
  'operator.quote_detail.more_aria': 'More actions',
  'operator.quote_detail.delete_confirm.title': 'Delete this quote?',
  'operator.quote_detail.delete_confirm.body':
    'Quote {ref} will be removed from the quotes list. It can still be recovered by a developer if needed.',
  'operator.quote_detail.tab.messages': 'Messages',
  'operator.quote_detail.tab.documents': 'Documents',
  'operator.quote_detail.converted.title': 'Converted to a shipment',
  'operator.quote_detail.converted.body':
    'Messages and documents moved to shipment {shipment_no} when this quote was booked. Manage them there.',
  'operator.quote_detail.converted.view_shipment': 'Open shipment',
  'operator.quote_detail.summary': 'Summary',
  'operator.quote_detail.summary.customer': 'Customer',
  'operator.quote_detail.summary.mode': 'Mode',
  'operator.quote_detail.summary.lane': 'Lane',
  'operator.quote_detail.summary.shipment': 'Shipment',
  'operator.quote_detail.summary.status': 'Status',
  'operator.quote_detail.summary.valid_until': 'Valid until',
  'operator.quote_detail.summary.total_cost': 'Total cost',
  'operator.quote_detail.summary.total_sell': 'Total sell',
  'operator.quote_detail.summary.margin': 'Margin',
  'operator.quote_detail.template_modal.title': 'Save as template',
  'operator.quote_detail.template_modal.cancel': 'Cancel',
  'operator.quote_detail.template_modal.save': 'Save template',
  'operator.quote_detail.template_modal.name': 'Template name',
  'operator.quote_detail.template_modal.default_name': 'Template from {ref}',
}

export const zhTW = {
  'operator.quote_detail.head': '{ref} — 報價',
  'operator.quote_detail.back': '返回報價列表',
  'operator.quote_detail.change_status_aria': '變更狀態',
  'operator.quote_detail.duplicate': '複製',
  'operator.quote_detail.edit': '編輯報價',
  'operator.quote_detail.change_status': '變更狀態',
  'operator.quote_detail.send': '傳送給客戶',
  'operator.quote_detail.send.draft_hint': '傳送後，此草稿將標記為已送出。',
  'operator.quote_detail.details': '明細',
  'operator.quote_detail.details.mode': '運輸類型',
  'operator.quote_detail.details.load': '裝載類型',
  'operator.quote_detail.details.incoterm': '貿易條件',
  'operator.quote_detail.details.transit': '運送時間',
  'operator.quote_detail.details.transit_days': '{days} 天',
  'operator.quote_detail.details.loading_port': '起運港',
  'operator.quote_detail.details.origin_location': '起運地點',
  'operator.quote_detail.details.discharge_port': '卸貨港',
  'operator.quote_detail.details.final_destination': '最終目的地',
  'operator.quote_detail.details.cargo': '貨物明細',
  'operator.quote_detail.details.remarks': '備註',
  'operator.quote_detail.charges': '費用',
  'operator.quote_detail.charges.sub': '內部成本與毛利 — 絕不會傳送至客戶入口',
  'operator.quote_detail.col.charge': '費用項目',
  'operator.quote_detail.col.cost': '成本',
  'operator.quote_detail.col.sell': '售價',
  'operator.quote_detail.col.margin': '毛利',
  'operator.quote_detail.total': '總計',
  'operator.quote_detail.save_as_template': '儲存為範本',
  'operator.quote_detail.convert': '轉換為貨件',
  'operator.quote_detail.duplicate_confirm.title': '複製這份報價？',
  'operator.quote_detail.duplicate_confirm.body':
    '這會依 {ref} 複製出一份新的草稿報價（含明細項目），之後可再編輯。',
  'operator.quote_detail.convert_confirm.title': '轉換為貨件？',
  'operator.quote_detail.convert_confirm.body':
    '這會將報價 {ref} 訂艙並建立一筆貨件，並把其訊息與文件移至該貨件。此操作無法復原。',
  'operator.quote_detail.delete': '刪除',
  'operator.quote_detail.delete_aria': '刪除報價',
  'operator.quote_detail.more_aria': '更多操作',
  'operator.quote_detail.delete_confirm.title': '刪除這份報價？',
  'operator.quote_detail.delete_confirm.body':
    '報價 {ref} 將從報價列表中移除。如有需要，仍可由開發人員復原。',
  'operator.quote_detail.tab.messages': '訊息',
  'operator.quote_detail.tab.documents': '文件',
  'operator.quote_detail.converted.title': '已轉換為貨件',
  'operator.quote_detail.converted.body':
    '此報價成立時，訊息與文件已移至貨件 {shipment_no}，請至該處管理。',
  'operator.quote_detail.converted.view_shipment': '開啟貨件',
  'operator.quote_detail.summary': '摘要',
  'operator.quote_detail.summary.customer': '客戶',
  'operator.quote_detail.summary.mode': '運輸方式',
  'operator.quote_detail.summary.lane': '航線',
  'operator.quote_detail.summary.shipment': '貨件',
  'operator.quote_detail.summary.status': '狀態',
  'operator.quote_detail.summary.valid_until': '有效至',
  'operator.quote_detail.summary.total_cost': '總成本',
  'operator.quote_detail.summary.total_sell': '總售價',
  'operator.quote_detail.summary.margin': '毛利',
  'operator.quote_detail.template_modal.title': '儲存為範本',
  'operator.quote_detail.template_modal.cancel': '取消',
  'operator.quote_detail.template_modal.save': '儲存範本',
  'operator.quote_detail.template_modal.name': '範本名稱',
  'operator.quote_detail.template_modal.default_name': '來自 {ref} 的範本',
}
